import styled from "@emotion/styled";

const NavMenuButton = styled.button<{ selected: boolean }>`
  color: ${(props) => (props.selected ? "#fff" : "#007bff")};
  background-color: ${(props) => (props.selected ? "#007bff" : "transparent")};
  border: 1px solid #007bff;
  border-radius: 4px;
  padding: 8px 12px;
  cursor: pointer;
`;

type NavMenuProps<T extends string> = {
  selected: T;
  items: { id: T; title: string }[];
  onSelect: (item: T) => void;
};

export function NavMenu<T extends string>(props: NavMenuProps<T>) {
  return (
    <div style={{ display: "flex", gap: "10px" }}>
      {props.items.map((item) => {
        return (
          <NavMenuButton
            key={item.id}
            selected={item.id == props.selected}
            onClick={() => props.onSelect(item.id)}
            data-testid={`nav-${item.id}`}
          >
            {item.title}
          </NavMenuButton>
        );
      })}
    </div>
  );
}
